import { useMutation } from "@apollo/client/react";
import useFetchShiftInstances from "hooks/apollo/shiftInstance/useFetchShiftInstances";
import { useSchedulerState } from "hooks/state/index";
import useTimeZone from "hooks/useTimeZone";
import { removeWorkBlock } from "./helpers/handleUpdateWorkBlocks";
import { UnscheduleWorkBlock } from "./workBlock.gql";

export default function useUnscheduleWorkBlock() {
  const { refetch: refetchShiftInstances } = useFetchShiftInstances();
  const [unscheduleWorkBlock] = useMutation(UnscheduleWorkBlock, {
    onCompleted: () => {
      refetchShiftInstances();
    },
  });
  const {
    state: { dataTimeRange },
  } = useSchedulerState();
  const { overrideToSiteTimeZone } = useTimeZone();

  return ({ id }) =>
    unscheduleWorkBlock({
      update: (proxy) => {
        const getAllBlocksVariables = {
          endsAt: overrideToSiteTimeZone(dataTimeRange.endDate),
          startsAt: overrideToSiteTimeZone(dataTimeRange.startDate),
        };

        removeWorkBlock(id, proxy, getAllBlocksVariables);
      },
      variables: { id },
    });
}
